<template>
    <card-seplag titulo="Ciclo de Recadastramento" cor="#00acc1" >
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12 p-md-4 p-md-offset-8">
                    <Button label="Novo" icon="pi pi-check" class="p-button-rounded" @click="novoCiclo()"/>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <table-seplag :dados.sync="ciclosRecadastramento" :exibirCabecalho="false" 
            :paginacao="true" :loading="loadingPaginacao" :totalRegistro.sync="totalRegistro" :urlPanagicao="urlPanagicao">  
                <Column bodyStyle="text-align: center" header="Data do Ciclo">
                        <template #body="slotProps">                                     
                                <span class="customer-badge-pentende"> {{slotProps.data.dataInicio+ " - "+ slotProps.data.dataFinal}}</span>
                        </template>
                </Column>  
                <Column bodyStyle="text-align: center" header="Descrição">
                        <template #body="slotProps">                                     
                                <span class="customer-badge-pentende"> {{slotProps.data.descCiclo}}</span>
                        </template>
                </Column>          
                <Column bodyStyle="text-align: center" header="Status">
                        <template #body="slotProps">                        
                                <span v-if="slotProps.data.statCiclo=='ABERTO'" class="summary-box-stats-aberto"> {{slotProps.data.statCiclo}}</span>    
                                <span v-else-if="slotProps.data.statCiclo=='FECHADO'" class="summary-box-stats-fechado"> {{slotProps.data.statCiclo}}</span>                       
                                <span v-else class="customer-badge-pentende"> {{slotProps.data.statCiclo}}</span>
                        </template>
                </Column>      
                <Column bodyStyle="text-align: center" headerStyle="width: 15em;" class="p-grid">
                    <template #body="linha" >
                        <Button v-tooltip="'Visualizar'" icon="pi pi-search" class="p-button-rounded" @click="visualizarCiclo(linha.data)"/>
                        <Button v-if="linha.data.statCiclo!='FECHADO'  && linha.data.statCiclo!='INATIVO'" v-tooltip="'Editar'" icon="pi pi-pencil" class="p-button-rounded p-button-warning margin-botao" @click="editarCiclo(linha.data)"/>
                        <Button v-if="linha.data.statCiclo!='PENDENTE' && linha.data.statCiclo!='FECHADO' && linha.data.statCiclo!='INATIVO'" v-tooltip="'Suspender'" icon="pi pi-exclamation-circle" class="p-button-rounded p-button-success margin-botao" @click="editarCiclo(linha.data)"/>
                        <Button v-if="linha.data.statCiclo!='PENDENTE' && linha.data.statCiclo!='FECHADO' && linha.data.statCiclo!='INATIVO'" v-tooltip="'Fechar'" icon="pi pi-times" class="p-button-rounded p-button-danger margin-botao" @click="fecharCiclo(linha.data)" />
                        <Button v-if="linha.data.statCiclo!='INATIVO' && linha.data.statCiclo=='FECHADO'" v-tooltip="'Deletar'" icon="pi pi-trash" class="p-button-rounded p-button-danger margin-botao" @click="deletarCiclo(linha.data)" />
                    </template>
                </Column>
            </table-seplag>
        </div>
    </card-seplag>  
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue'
import { baseApiUrl } from '@/config/global'

export default {
    name: "listaCiclo",
    components: {CardSeplag, TableSeplag},
    data: function(){        
		return {
            loadingPaginacao: false,
            totalRegistro: 1,
            urlPanagicao: '',
            ciclosRecadastramento:[ ]
        }
    },
    methods:{        
       async carregarDados(){     
            await this.$http.get(`${baseApiUrl}/ciclos/all`).then(res =>{
                this.ciclosRecadastramento = res.data
            })
       },
       novoCiclo(){
            this.$store.commit('setCicloSelecionado', {descCiclo: " ", dataInicio: " ", dataFinal: ""})
            this.$router.push({name:'gerenciaNovoCiclo'})
       },
       editarCiclo(ciclo){
            this.$store.commit('setCicloSelecionado', ciclo)
            this.$router.push({name:'gerenciaNovoCiclo'})
       },
       deletarCiclo(data) {
        this.$http.delete(`${baseApiUrl}/ciclos/${data.idenCiclo}` , JSON.stringify(data))
   
       },
       visualizarCiclo(ciclo) {
        this.$store.commit('setCicloSelecionado', ciclo)
        this.$router.push({name:'visualizarCiclo'})
       },
        async fecharCiclo(data) {
         data.statCiclo = "FECHADO";
        await  this.$http.put(`${baseApiUrl}/ciclos/${data.idenCiclo}`, JSON.stringify(data))
        
        
       }
    },
    mounted(){        
        this.carregarDados()
    }

}
</script>

<style>
    .summary-box-stats-aberto  {
        background-color: #0ca852 !important;
    }
    .summary-box-stats-fechado{
        color: #f03a3a;
    }
    .summary-box-status-pentende{
        background-color: #EE7600 !important;
        
    }
    .margin-botao{
        margin-left: 4px !important;
    }
</style>